import {
    CALCULATE_QUOTATION,
    CALCULATE_QUOTATION_FAIL,
    CALCULATE_QUOTATION_SUCCESS,
    CREATE_QUOTATION,
    CREATE_QUOTATION_FAIL,
    CREATE_QUOTATION_SUCCESS,
    UPDATE_QUOTATION,
    UPDATE_QUOTATION_FAIL,
    UPDATE_QUOTATION_SUCCESS,
    DELETE_QUOTATION,
    DELETE_QUOTATION_FAIL,
    DELETE_QUOTATION_SUCCESS,
    GET_QUOTATION_DETAILS,
    GET_QUOTATION_DETAILS_FAIL,
    GET_QUOTATION_DETAILS_SUCCESS,
    GET_QUOTATION_LISTING,
    GET_QUOTATION_LISTING_FAIL,
    GET_QUOTATION_LISTING_SUCCESS,
    GET_QUOTATION_FILTERS,
    GET_QUOTATION_FILTERS_FAIL,
    GET_QUOTATION_FILTERS_SUCCESS,
    RESET_QUOTATION_ACTION_STATE,
    SEND_QUOTATION_EMAIL,
    SEND_QUOTATION_EMAIL_FAIL,
    SEND_QUOTATION_EMAIL_SUCCESS,
    SEND_QUOTATION_WHATSAPP,
    SEND_QUOTATION_WHATSAPP_FAIL,
    SEND_QUOTATION_WHATSAPP_SUCCESS,
} from "./actionTypes";

export const calculateQuotation = data => ({ type: CALCULATE_QUOTATION, payload: data });
export const calculateQuotationSuccess = data => ({ type: CALCULATE_QUOTATION_SUCCESS, payload: data });
export const calculateQuotationFail = error => ({ type: CALCULATE_QUOTATION_FAIL, payload: error });
export const sendQuotationEmail = data => ({ type: SEND_QUOTATION_EMAIL, payload: data });
export const sendQuotationEmailSuccess = data => ({ type: SEND_QUOTATION_EMAIL_SUCCESS, payload: data });
export const sendQuotationEmailFail = error => ({ type: SEND_QUOTATION_EMAIL_FAIL, payload: error });
export const sendQuotationWhatsapp = data => ({ type: SEND_QUOTATION_WHATSAPP, payload: data });
export const sendQuotationWhatsappSuccess = data => ({ type: SEND_QUOTATION_WHATSAPP_SUCCESS, payload: data });
export const sendQuotationWhatsappFail = error => ({ type: SEND_QUOTATION_WHATSAPP_FAIL, payload: error });

export const getQuotationListing = (data) => ({
    type: GET_QUOTATION_LISTING,
    payload: data,
});

export const getQuotationListingSuccess = data => ({
    type: GET_QUOTATION_LISTING_SUCCESS,
    payload: data,
});

export const getQuotationListingFail = error => ({
    type: GET_QUOTATION_LISTING_FAIL,
    payload: error,
});

export const getQuotationDetails = (data) => ({
    type: GET_QUOTATION_DETAILS,
    payload: data,
});

export const getQuotationDetailsSuccess = data => ({
    type: GET_QUOTATION_DETAILS_SUCCESS,
    payload: data,
});

export const getQuotationDetailsFail = error => ({
    type: GET_QUOTATION_DETAILS_FAIL,
    payload: error,
});

export const createQuotation = (data) => ({
    type: CREATE_QUOTATION,
    payload: data,
});

export const createQuotationSuccess = data => ({
    type: CREATE_QUOTATION_SUCCESS,
    payload: data,
});

export const createQuotationFail = error => ({
    type: CREATE_QUOTATION_FAIL,
    payload: error,
});

export const getQuotationFilters = () => ({ type: GET_QUOTATION_FILTERS });
export const getQuotationFiltersSuccess = data => ({ type: GET_QUOTATION_FILTERS_SUCCESS, payload: data });
export const getQuotationFiltersFail = error => ({ type: GET_QUOTATION_FILTERS_FAIL, payload: error });

export const updateQuotation = data => ({ type: UPDATE_QUOTATION, payload: data });
export const updateQuotationSuccess = data => ({ type: UPDATE_QUOTATION_SUCCESS, payload: data });
export const updateQuotationFail = error => ({ type: UPDATE_QUOTATION_FAIL, payload: error });

export const deleteQuotation = (data) => ({
    type: DELETE_QUOTATION,
    payload: data,
});

export const deleteQuotationSuccess = data => ({
    type: DELETE_QUOTATION_SUCCESS,
    payload: data,
});

export const deleteQuotationFail = error => ({
    type: DELETE_QUOTATION_FAIL,
    payload: error,
});

//reset
export const resetQuotationActionState = () => {
    return {
        type: RESET_QUOTATION_ACTION_STATE,
    }
}
